import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChartLine, faPlus, faSortDown, faSortUp} from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import {useTranslation} from "react-i18next";

const SymptomTableHeader = ({ children, sortedSymptoms, onHandleShowSymptomsLineChart, sortConfig, onHandleSortChange,
                              selectSymptomModule, printView, onSetSelectSymptomModule}) => {
  const { t: t } = useTranslation();

  const sortOptions = [
    { value: "startDate", label: t("date") },
    { value: "type", label: t("type") },
    { value: "term", label: t("symptom") },
  ];

  return (
    <div>
      <>
        <header className="w3-container w3-center w3-padding-small">
          <div className="w3-display-container w3-padding-small">
            {children}
            {sortedSymptoms?.length > 0 && (
              <div className="w3-display-right ">
                <button
                  className="w3-btn w3-round-xlarge w3-theme-d5 "
                  onClick={() => onHandleShowSymptomsLineChart(null)}
                >
                  <FontAwesomeIcon icon={faChartLine} />
                </button>
              </div>
            )}
          </div>
        </header>
        <div className="w3-row w3-padding-small">
          <div className="w3-col s2">
            {sortedSymptoms?.length > 0 ? (
              <label className="w3-right w3-padding-small w3-right">
                {t("sort_by")}:
              </label>
            ) : (
              <div className="w3-container"></div>
            )}
          </div>
          <div className="w3-col s6">
            {sortedSymptoms?.length > 0 ? (
              <div className="flex-aligned-items">
                <Select
                  onChange={(selectedOption) =>
                    onHandleSortChange(selectedOption?.value)
                  }
                  value={sortOptions?.find(
                    (option) => option?.value === sortConfig?.key,
                  )}
                  options={sortOptions}
                  placeholder={t("select")}
                  className="custom-select"
                  classNamePrefix="custom-select"
                />
                <FontAwesomeIcon
                  onClick={() => onHandleSortChange(sortConfig?.key)}
                  icon={sortConfig?.ascending ? faSortUp : faSortDown}
                  className="w3-left w3-padding-small"
                />
              </div>
            ) : (
              <div className="w3-container"></div> /* empty container required to right align add button in case of an empty list  */
            )}
          </div>
          <div className="w3-col s4 w3-right-align">
            {!selectSymptomModule && !printView && (
              <button
                className="w3-btn w3-round-xlarge w3-theme-d5 responsive-button"
                onClick={() => onSetSelectSymptomModule(true)}
              >
                <FontAwesomeIcon icon={faPlus} />{" "}
                {t("add_new_symptom_report")}
              </button>
            )}
          </div>
        </div>
      </>
    </div>
  );
}

export default SymptomTableHeader;